import React from 'react'
import intl from 'react-intl-universal'
import http from 'axios'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Header from './Header'
import Footer from './Footer'
import { isDark, brandStyle } from '../utils/Tools'
import { normalizeLang, locales } from '../utils/LangUtils';

require('bootstrap/dist/css/bootstrap.min.css')
require('../styles/App.scss')
require('../styles/hc.scss')

const axios = require('axios')

const mapStateToProps = state => ({
  authenticated: state.auth.session.id !== false,
  lang: state.router.location.query.lang
})

class AppComponent extends React.Component {

  constructor() {
    super()
    this.state = {
      initDone: false
    }
    let conf = window.ODOO
    if (typeof conf == 'undefined'){
      conf = {
        url: window.location.hostname.replace('podsumowanie', 'gateway'),
        port: ''
      }
    }

    if(document.querySelector('.logoStyle') === null){
      let logo = document.createElement('style')
      logo.classList.add('logoStyle')
      logo.innerHTML +=`
        #root header .logo{
          background-image: url(${conf.url + (conf.port?':'+conf.port:'')}/web/binary/company_logo)
        }
        `
      document.getElementsByTagName('head')[0].appendChild(logo)
    }
    if(document.querySelector('.brandStyle') === null){
      let brandUrl = conf.url + (conf.port?':'+conf.port:'')+'/brand/'
      axios.get(brandUrl).then((response) => {
        if(response.status === 200){
          let kolor = response.data
          let style = document.createElement('style')
          style.classList.add('brandStyle')
          let kolor_text = '#000'
          if(isDark(kolor)){
            kolor_text = '#fff'
          }
          if (kolor){
            style.innerHTML = brandStyle(kolor, kolor_text)
          }
          document.getElementsByTagName('head')[0].appendChild(style)
        }
      }).catch(() => {
        // no brand data - do nothing
      })
    }
    let spinner = document.querySelector('.loaderWrap')
    if (spinner) spinner.style.display = 'none'
  }

  componentDidMount(){
    this.loadLocales()
  }

  componentDidUpdate() {
    const { lang } = this.props
    const normalizedLang = normalizeLang(lang)

    // Reload only if the language is different and needs a reload
    if (normalizedLang && intl.options.currentLocale !== normalizedLang) {
      window.location.reload()
    }
  }
  
  loadLocales() {
    let { lang } = this.props
  
    lang = normalizeLang(lang)
  
    console.log('Using lang:', lang)
  
    let currentLocale = lang || intl.determineLocale({
      localStorageLocaleKey: 'lang'
    })
  
    if (!locales.find(l => l.value === currentLocale)) {
      currentLocale = 'pl-PL'
    }
  
    http.get(`translations/${currentLocale}.json`).then(res => {
      // init method will load CLDR locale data according to currentLocale
      return intl.init({
        currentLocale,
        locales: { [currentLocale]: res.data }
      })
    }).then(() => {
      this.setState({ initDone: true })
  
      const url = new URL(window.location)
      if (url.searchParams.has('lang')) {
        url.searchParams.delete('lang')
        window.history.replaceState({}, '', url)
      }
  
      document.querySelector('.loaderWrap').style.display = 'none'
    })
  }

  render() {
    const {authenticated, children} = this.props
    const {initDone} = this.state
    return (
      initDone &&
      <article>
        <Header authenticated={authenticated}/>
        <main>
          {children}
        </main>
        <Footer locales={locales}/>
      </article>
    )
  }
}
const App = connect(mapStateToProps)(AppComponent)

export default withRouter(App)
